import sliceCreator from '../../index.jsx';
import {FARMER_COMMITMENT} from '../../../constants/index.jsx';
const _farmerCommitmentAction = sliceCreator('FARMER_COMMITMENT', FARMER_COMMITMENT, 'post');

const { asyncAction: farmerCommitmentAction, reducer, clearData: clearfarmerCommitmentAction } = _farmerCommitmentAction;

export default reducer;

export {
    farmerCommitmentAction,
    clearfarmerCommitmentAction
}